import React, { useState } from 'react';
import './ServicesManagement.css';
import IconPicker from '../IconPicker';
import ImageContainer from './ImageContainer';

/**
 * 🎯 SERVICES MANAGEMENT COMPONENT 2025
 * 
 * Toggle-Sektion für Simplistic Services nach Design-Guide:
 * - 1:1 Text-Edit-Design
 * - Dynamische Services kompakt zusammengefasst
 * - Icon-Management für jeden Service
 * - Add/Remove-Funktionalität
 * - Spezifische Klassennamen
 */
function ServicesManagement({
    services,
    addService,
    removeService,
    updateService,
    handleServiceIconUpload,
    handleServiceImageUpload,
    handleIconSelect,
    uploadingStates,
    iconPickerStates,
    setIconPickerState,
    setUploadingState,
    editData,
    handleInputChange,
    uploadImage,
    getServiceUploadState,
    setServiceUploadState
}) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="services-management">
            {/* Toggle Header */}
            <div 
                className={`services-header ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpanded}
            >
                <div className="services-header-content">
                    <div className="services-header-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M2 3h12v10H2V3zM6 7h4M6 9h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            <circle cx="4" cy="5" r="0.5" fill="currentColor"/>
                            <circle cx="4" cy="7" r="0.5" fill="currentColor"/>
                            <circle cx="4" cy="9" r="0.5" fill="currentColor"/>
                        </svg>
                    </div>
                    <h3 className="services-header-title">Services</h3>
                    <div className="services-counter">
                        {services?.length || 0}
                    </div>
                </div>
                <div className={`services-toggle-arrow ${isExpanded ? 'expanded' : ''}`}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path 
                            d="M4 6L8 10L12 6" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>

            {/* Expanded Content */}
            {isExpanded && (
                <div className="services-content">
                    {/* Add Button */}
                    <div className="add-service-section">
                        <button
                            onClick={addService}
                            className="add-service-btn"
                        >
                            <div className="btn-icon">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M7 3V11M3 7H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                            </div>
                            <span>Add New Service</span>
                        </button>
                        <div className="add-service-hint">
                            Create compelling services to showcase your offerings
                        </div>
                    </div>

                    {/* Services Grid */}
                    {services && services.length > 0 && (
                        <div className="services-grid">
                            {services.map((service, index) => (
                                <div key={service.id || index} className="service-edit-card">
                                    {/* Card Header */}
                                    <div className="service-card-header">
                                        <div className="service-card-title">
                                            <div className="service-card-number">{index + 1}</div>
                                            <span>Service</span>
                                            {/* ✅ SIMPLE STATUS DOT */}
                                            <div className={`service-title-status-dot ${service.visible !== false ? 'dot-visible' : 'dot-hidden'}`}></div>
                                        </div>
                                        <div className="service-header-actions">
                                            {/* ✅ SIMPLE ON/OFF TOGGLE */}
                                            <div 
                                                className={`service-visibility-toggle ${service.visible !== false ? 'toggle-on' : 'toggle-off'}`}
                                                onClick={() => updateService(index, 'visible', service.visible !== false ? false : true)}
                                                title={service.visible !== false ? 'Hide service' : 'Show service'}
                                            >
                                                <div className="toggle-switch-slider">
                                                    <div className="toggle-switch-knob"></div>
                                                </div>
                                                <span className="toggle-switch-label">
                                                    {service.visible !== false ? 'ON' : 'OFF'}
                                                </span>
                                            </div>
                                            <button
                                                onClick={() => removeService(index)}
                                                className="service-remove-btn"
                                                title="Remove service"
                                            >
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                    <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>

                                    {/* ✅ MODERNES MEDIA SYSTEM - Clean & Übersichtlich */}
                                    <div className="service-media-section-modern">
                                        
                                        {/* Media Preview & Toggle */}
                                        <div className="media-preview-container">
                                            {/* Preview Box */}
                                            <div className="media-preview-box">
                                                {service.useImage === true && service.serviceImage ? (
                                                    <img src={service.serviceImage} alt="Service" className="media-preview-image" />
                                                ) : !service.useImage && (service.icon || service.customIcon) ? (
                                                    <img 
                                                        src={(() => {
                                                            const iconSrc = service.iconType === 'upload' ? service.customIcon : service.icon;
                                                            console.log('🖼️ Edit preview icon source:', {
                                                                serviceIndex: index,
                                                                iconType: service.iconType,
                                                                customIcon: service.customIcon,
                                                                icon: service.icon,
                                                                finalSrc: iconSrc
                                                            });
                                                            return iconSrc;
                                                        })()} 
                                                        alt="Service Icon"
                                                        className="media-preview-icon"
                                                        onError={(e) => {
                                                            console.error('❌ Edit preview icon failed to load:', e.target.src);
                                                        }}
                                                        onLoad={() => {
                                                            console.log('✅ Edit preview icon loaded successfully');
                                                        }}
                                                    />
                                                ) : (
                                                    <div className="media-preview-placeholder">
                                                        {service.useImage === true ? (
                                                            <div className="placeholder-content">
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                                                                    <circle cx="8.5" cy="8.5" r="1.5" stroke="currentColor" strokeWidth="1.5"/>
                                                                    <polyline points="21,15 16,10 5,21" stroke="currentColor" strokeWidth="1.5"/>
                                                                </svg>
                                                                <span>Image</span>
                                                            </div>
                                                        ) : (
                                                            <div className="placeholder-content">
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" stroke="currentColor" strokeWidth="1.5"/>
                                                                </svg>
                                                                <span>Icon</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            
                                            {/* Toggle Switch */}
                                            <div className="media-toggle-container">
                                                <label className="modern-toggle">
                                                    <input
                                                        type="checkbox"
                                                        checked={service.useImage === true}
                                                        onChange={(e) => updateService(index, 'useImage', e.target.checked)}
                                                    />
                                                    <div className="toggle-track">
                                                        <div className="toggle-thumb">
                                                            {service.useImage === true ? '🖼️' : '⚡'}
                                                        </div>
                                                    </div>
                                                    <span className="toggle-text">
                                                        {service.useImage === true ? 'Image Mode' : 'Icon Mode'}
                                                    </span>
                                                </label>
                                            </div>
                                        </div>

                                        {/* Action Buttons */}
                                        <div className="media-actions">
                                            {service.useImage === true ? (
                                                /* IMAGE ACTIONS */
                                                <div className="action-buttons">
                                                    <label className="action-btn primary">
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(e) => handleServiceImageUpload(index, e.target.files[0])}
                                                            style={{ display: 'none' }}
                                                        />
                                                        {getServiceUploadState(index) ? (
                                                            <>
                                                                <div className="btn-spinner"></div>
                                                                Uploading...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                                </svg>
                                                                {service.serviceImage ? 'Change' : 'Upload'}
                                                            </>
                                                        )}
                                                    </label>
                                                    {service.serviceImage && (
                                                        <button 
                                                            className="action-btn secondary"
                                                            onClick={() => updateService(index, 'serviceImage', '')}
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                                <polyline points="3,6 5,6 21,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                                <path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                            Remove
                                                        </button>
                                                    )}
                                                </div>
                                            ) : (
                                                /* ICON ACTIONS */
                                                <div className="action-buttons">
                                                    <button
                                                        className={`action-btn ${iconPickerStates[index] ? 'active' : 'primary'}`}
                                                        onClick={() => setIconPickerState(index, !iconPickerStates[index])}
                                                    >
                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
                                                            <path d="m12 1 3 6 6 3-6 3-3 6-3-6-6-3 6-3 3-6z" stroke="currentColor" strokeWidth="2"/>
                                                        </svg>
                                                        Icons
                                                    </button>
                                                    
                                                    <label className="action-btn secondary">
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(e) => handleServiceIconUpload(index, e.target.files[0])}
                                                            style={{ display: 'none' }}
                                                        />
                                                        {uploadingStates[index] ? (
                                                            <>
                                                                <div className="btn-spinner"></div>
                                                                Uploading...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                                </svg>
                                                                Upload
                                                            </>
                                                        )}
                                                    </label>

                                                    {(service.icon || service.customIcon) && (
                                                        <button
                                                            className="action-btn danger"
                                                            onClick={() => {
                                                                updateService(index, 'icon', '');
                                                                updateService(index, 'customIcon', '');
                                                            }}
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                                <polyline points="3,6 5,6 21,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                                <path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                            Clear
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        {/* Icon Picker Overlay */}
                                        {iconPickerStates[index] && (
                                            <div className="icon-picker-overlay">
                                                <div className="icon-picker-header">
                                                    <span>Choose an Icon</span>
                                                    <button 
                                                        className="close-btn"
                                                        onClick={() => setIconPickerState(index, false)}
                                                    >
                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                            <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                            <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                                <IconPicker
                                                    onSelect={(selectedIcon) => handleIconSelect(index, selectedIcon)}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    {/* ✅ MODERNE TEXT FIELDS */}
                                    <div className="service-content-modern">
                                        <div className="content-grid">
                                            <div className="field-group">
                                                <label className="field-label">
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                                        <path d="M4 7V4a1 1 0 0 1 1-1h2m0 0V1m0 2h2m0 0V1m0 2h2m0 0V1m0 2h2a1 1 0 0 1 1 1v3M4 7h16M4 7v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7" stroke="currentColor" strokeWidth="1.5"/>
                                                    </svg>
                                                    Service Name
                                                </label>
                                                <input
                                                    type="text"
                                                    value={service.name || ''}
                                                    onChange={(e) => updateService(index, 'name', e.target.value)}
                                                    placeholder="Web Development, Consulting..."
                                                    className="modern-input"
                                                />
                                            </div>

                                            <div className="field-group">
                                                <label className="field-label">
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="1.5"/>
                                                        <polyline points="14,2 14,8 20,8" stroke="currentColor" strokeWidth="1.5"/>
                                                        <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" strokeWidth="1.5"/>
                                                        <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" strokeWidth="1.5"/>
                                                    </svg>
                                                    Description
                                                </label>
                                                <textarea
                                                    value={service.description || ''}
                                                    onChange={(e) => updateService(index, 'description', e.target.value)}
                                                    placeholder="Describe your service and its benefits..."
                                                    className="modern-textarea"
                                                    rows={3}
                                                />
                                            </div>

                                            <div className="field-group">
                                                <label className="field-label">
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                                        <line x1="12" y1="1" x2="12" y2="23" stroke="currentColor" strokeWidth="1.5"/>
                                                        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="currentColor" strokeWidth="1.5"/>
                                                    </svg>
                                                    Price
                                                </label>
                                                <input
                                                    type="text"
                                                    value={service.price || ''}
                                                    onChange={(e) => updateService(index, 'price', e.target.value)}
                                                    placeholder="$99, €150/mo, Free..."
                                                    className="modern-input price-input"
                                                />
                                            </div>

                                            {/* ✅ BUTTON TEXT FIELD - NEU */}
                                            <div className="field-group">
                                                <label className="field-label">
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                                        <rect x="3" y="6" width="18" height="12" rx="2" ry="2" stroke="currentColor" strokeWidth="1.5"/>
                                                        <circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="1.5"/>
                                                    </svg>
                                                    Button Text
                                                </label>
                                                <input
                                                    type="text"
                                                    value={service.buttonText || ''}
                                                    onChange={(e) => updateService(index, 'buttonText', e.target.value)}
                                                    placeholder="Learn More, Get Started, Book Now..."
                                                    className="modern-input"
                                                />
                                            </div>

                                            {/* ✅ BUTTON LINK FIELD - NEU */}
                                            <div className="field-group">
                                                <label className="field-label">
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="currentColor" strokeWidth="1.5"/>
                                                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="1.5"/>
                                                    </svg>
                                                    Button Link
                                                </label>
                                                <input
                                                    type="text"
                                                    value={service.buttonLink || ''}
                                                    onChange={(e) => updateService(index, 'buttonLink', e.target.value)}
                                                    placeholder="https://example.com, /contact, #section..."
                                                    className="modern-input"
                                                />
                                            </div>

                                            {/* ✅ BUTTON VISIBILITY TOGGLE - NEU */}
                                            <div className="field-group">
                                                <label className="field-label">
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="1.5"/>
                                                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5"/>
                                                    </svg>
                                                    Show Button
                                                </label>
                                                <label className="toggle-switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={service.showButton !== false}
                                                        onChange={(e) => updateService(index, 'showButton', e.target.checked)}
                                                    />
                                                    <span className="toggle-slider"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Empty State */}
                    {(!services || services.length === 0) && (
                        <div className="services-empty-state">
                            <div className="services-empty-state-icon">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2" strokeDasharray="3 3" opacity="0.3"/>
                                    <path d="M16 18h16v12H16V18zM20 22h8M20 24h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
                                    <circle cx="18" cy="20" r="0.5" fill="currentColor" opacity="0.5"/>
                                    <circle cx="18" cy="22" r="0.5" fill="currentColor" opacity="0.5"/>
                                    <circle cx="18" cy="24" r="0.5" fill="currentColor" opacity="0.5"/>
                                </svg>
                            </div>
                            <h4>No Services Yet</h4>
                            <p>Click "Add New Service" to create your first service offering</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default ServicesManagement;
